// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"49525359","455":"139b2491","977":"0731fa4f"}[chunkId] + ".chunk.js";
};